import React from 'react';
import { FormGroup, TextInput, TextInputProps } from '@patternfly/react-core';

type Props = {
  id?: string;
  label?: string;
  name?: string;
  onChange?: (value: string) => void;
  readonly?: boolean;
  required?: boolean;
  value?: string;
  options?: {
    type?:
      | 'number'
      | 'email'
      | 'search'
      | 'time'
      | 'text'
      | 'date'
      | 'datetime-local'
      | 'month'
      | 'password'
      | 'tel'
      | 'url';
    min?: number;
    max?: number;
  };
};

const PatternflyInput = ({
  id,
  label,
  name,
  onChange,
  readonly,
  required,
  value,
  options,
}: Props) => {
  const additionalProps: TextInputProps = {};
  const { type = 'text' } = options;
  additionalProps.type = type;
  if (type === 'number') {
    const { min, max } = options;
    if (typeof min === 'number') {
      additionalProps.min = min;
    }
    if (typeof max === 'number') {
      additionalProps.max = max;
    }
  }

  return (
    <FormGroup label={label} isRequired={required}>
      <TextInput
        id={id}
        isDisabled={readonly}
        isRequired={required}
        name={name}
        onChange={(_, text) => onChange(text)}
        value={value}
        {...additionalProps}
      />
    </FormGroup>
  );
};

export default PatternflyInput;
